import { combineReducers, ActionReducerMap, ActionReducer } from '@ngrx/store';
import { createSelector } from 'reselect';
import * as fromCompanies from './companies.reducer';
import * as fromCompany from './company.reducer';
import * as fromComparison from './comparison.reducer';
import * as fromUser from './user.reducer';
import * as fromCompanyAnalysis from './company-analysis.reducer';
import * as fromPlatform from './platform.reducer';
import * as fromUsers from './users.reducer';
import * as fromUniverse from './universe.reducer';
import * as fromApp from './app.reducer';

export interface State {
  companies: fromCompanies.State;
  company: fromCompany.State;
  comparison: fromComparison.State;
  companyAnalysis: fromCompanyAnalysis.State;
  user: fromUser.State;
  users: fromUsers.State;
  platform: fromPlatform.State;
  universe: fromUniverse.State;
  app: fromApp.State;
}

export const appReducer = createReducer();

export function createReducer(asyncReducers = {}): ActionReducer<any> {
  return combineReducers(Object.assign({
    companies: fromCompanies.reducer,
    company: fromCompany.reducer,
    comparison: fromComparison.reducer,
    companyAnalysis: fromCompanyAnalysis.reducer,
    user: fromUser.reducer,
    users: fromUsers.reducer,
    platform: fromPlatform.reducer,
    universe: fromUniverse.reducer,
    app: fromApp.reducer,
    // any other reducers you always want to be available
  }, asyncReducers));
}

export const reducer: ActionReducerMap<State> = {
  companies: fromCompanies.reducer,
  company: fromCompany.reducer,
  comparison: fromComparison.reducer,
  companyAnalysis: fromCompanyAnalysis.reducer,
  user: fromUser.reducer,
  users: fromUsers.reducer,
  universe: fromUniverse.reducer,
  app: fromApp.reducer,
  platform: fromPlatform.reducer
};

//List all the state objects here
export const getCompanyState = (state: State) => state.company;
export const getComparisonState = (state: State) => state.comparison;
export const getCompaniesState = (state: State) => state.companies;
export const getCompanyAnalysisState = (state: State) => state.companyAnalysis;
export const getUserState = (state: State) => state.user;
export const getUsersState = (state: State) => state.users;
export const getPlatformState = (state: State) => state.platform;
export const getUniverseState = (state: State) => state.universe;
export const getAppState = (state: State) => state.app;

//List helper functions to access parts of state
export const getCompanies = createSelector(getCompaniesState, fromCompanies.getCompanies);
export const getCompanyMeta = createSelector(getCompaniesState, fromCompanies.getCompanyMeta);
export const getFuzzyResults = createSelector(getCompaniesState, fromCompanies.getFuzzyResults);
export const getFilters = createSelector(getUserState, fromUser.getFilters);

export const getCompany = createSelector(getCompanyState, fromCompany.getCompany);
export const getShowCashflow = createSelector(getCompanyState, fromCompany.getShowCashflow);

export const getComparison = createSelector(getComparisonState, fromComparison.getComparison);
export const getComparisonCompanies = createSelector(getComparisonState, fromComparison.getComparisonCompanies);

export const getCompanyAnalysis = createSelector(getCompanyAnalysisState, fromCompanyAnalysis.getCompanyAnalysis);
export const getUpper = createSelector(getCompanyAnalysisState, fromCompanyAnalysis.getUpper);
export const getLower = createSelector(getCompanyAnalysisState, fromCompanyAnalysis.getLower);
export const getAll = createSelector(getCompanyAnalysisState, fromCompanyAnalysis.getAll);
export const geFilteredResults = createSelector(getCompanyAnalysisState, fromCompanyAnalysis.getFilteredResults);

export const getFilteredResultsConfig = createSelector(getCompanyAnalysisState, fromCompanyAnalysis.getFilteredResultsConfig);
export const getUser = createSelector(getUserState, fromUser.getUser);

export const getPlatformInfo = createSelector(getPlatformState, fromPlatform.getPlatformInfo);
export const getSectors = createSelector(getPlatformState, fromPlatform.getSectors);
export const getRegions = createSelector(getPlatformState, fromPlatform.getRegions);
export const getSyntheticRegions = createSelector(getPlatformState, fromPlatform.getSyntheticRegions);
export const getCompaniesErrors = createSelector(getPlatformState, fromPlatform.getCompaniesErrors);
export const getUpdates = createSelector(getPlatformState, fromPlatform.getUpdates);

export const getUsers = createSelector(getUsersState, fromUsers.getUsers);
export const getScreensFilter = createSelector(getUserState, fromUser.getScreensFilter);
export const getUpperFilter = createSelector(getUserState, fromUser.getUpperFilter);
export const getLowerFilter = createSelector(getUserState, fromUser.getLowerFilter);

export const getUniverse = createSelector(getUniverseState, fromUniverse.getUniverse);
export const getApp = createSelector(getAppState, fromApp.getApp );
export const getContactState = createSelector(getAppState, fromApp.getContactState );



// WEBPACK FOOTER //
// ./src/reducers/index.ts